import "./styles.css";
import { Box, Grid, Container } from "@mui/material";
import { useFormik } from "formik";
import { useNavigate, useParams } from "react-router-dom";
import {
  clearLocalStorageData,
  removeLocalStorageData,
  setLocalStorageData,
} from "../../../../shared/utils/localStorage";
import { LoadingButton } from "@mui/lab";
// import LoginImage from "./images/login.svg";
import InputTextfield from "../../../../shared/components/textField";
import { getValidationSchema } from "../../../../shared/validations/schema";
// import Logo from "../../../../shared/components/logo";
import useMutation from "../../../../shared/components/hooks/useMutation";
import ResetImg from "../../../../assets/img/reset-text.svg";
import ForgotBg from "../../../../assets/img/forgot-bg.svg";
import GcomLogo from "../../../../assets/img/dashboard-title.svg";
import login_bg from "../../../../assets/img/login_bg.jpg";
const App = () => {
  const { id } = useParams();
  setLocalStorageData("token", id);
  const { loading, modifyData } = useMutation("/login");
  const navigate = useNavigate();

  const textFields = [
    {
      id: "login-new-password",
      name: "newPassword",
      label: "New Password",
      placeholder: "Enter new password",
      type: "password",
    },
    {
      id: "login-confirm-password",
      name: "confirmPassword",
      label: "Confirm Password",
      placeholder: "Confirm new password",
      type: "password",
    },
  ];

  const passwordResetForm = useFormik({
    initialValues: {
      newPassword: "",
      confirmPassword: "",
    },
    validationSchema: getValidationSchema(["newPassword", "confirmPassword"]),
    onSubmit: async (formData: any) => {
      const response = await modifyData(`/user/reset-password`, "post", {
        password: formData.newPassword,
      });
      if (response) removeLocalStorageData("token");
    },
  });

  const handleCancelClick = () => {
    clearLocalStorageData();
    navigate("/login");
  };

  return (
    <>
      <Box
        sx={{
          minHeight: "100vh",
          backgroundImage: `url(${login_bg})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
        }}
      >
        <Container>
          <Box className="menuContainer">
            <Grid container>
              <Grid item md={1.85} className="logoContainer">
                <img src={GcomLogo} alt="" />
              </Grid>
            </Grid>
          </Box>
          <img className="forgot-bg" src={ForgotBg} alt="" />
          <Box sx={{ padding: "0.5% 12% 4% 12%" }}>
            <Grid container justifyContent="flex-end">
              {" "}
              <Grid item md={6} className="loginGridWrapper">
                <img src={ResetImg} className="forgot-img" alt="" />
                {/* <div className="leftCircle"></div> */}

                <div className="loginGridContainer">
                  <form
                    onSubmit={passwordResetForm.handleSubmit}
                    autoComplete="off"
                    className="forgotPasswordForm"
                  >
                    {textFields.map((field: any, index: number) => {
                      return (
                        <InputTextfield
                          key={index}
                          form={passwordResetForm}
                          className="mediumInputBox"
                          fieldProps={field}
                          information="Password must contain at least 8 character, including upper case, lower case, numeric value and special character"
                        />
                      );
                    })}
                    <Grid
                      container
                      sx={{ alignItems: "center", justifyContent: "flex-end" }}
                    >
                      <Grid
                        item
                        md={3}
                        className="cancelButton"
                        onClick={handleCancelClick}
                        role="button"
                        tabIndex={0}
                        style={{ cursor: "pointer" }}
                      >
                        Cancel
                      </Grid>
                      <Grid item md={5}>
                        <LoadingButton
                          disabled={
                            passwordResetForm.values.newPassword === "" ||
                            passwordResetForm.values.confirmPassword === ""
                          }
                          className="signInButton"
                          loading={loading}
                          variant="contained"
                          type="submit"
                          fullWidth
                          size="small"
                        >
                          Set Password
                        </LoadingButton>
                      </Grid>
                    </Grid>
                  </form>
                </div>
                {/* <div className="rightCircle"></div> */}
              </Grid>
              <Grid item md={0.85}></Grid>
            </Grid>
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default App;
